import { FixbotCTA } from '@ifixit/fixbot/fixbot-cta';
import initializeComponent from 'Shared/react-initialize';

function DocumentFixbotCTACard({
   documentId,
   fixbotOrigin,
}: {
   documentId: number;
   fixbotOrigin: string;
}) {
   return (
      <FixbotCTA
         origin={fixbotOrigin}
         contentType="file"
         contentId={documentId}
         analyticsCategory="Document"
         translationNamespace="FixbotCTADocument"
      />
   );
}

initializeComponent('DocumentFixbotCTACard', DocumentFixbotCTACard);
